import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";


export const getCuentasBancariasTotales = async () => {
    const respuesta = await PrivateInterceptor(`Base/Global/Bancos/CuentasBancariasTotales`, "GET");
    return respuesta;
};
